import React from "react";

import { FormControlLabel, Checkbox } from "@mui/material";
import { Controller, FieldPath } from "react-hook-form";
import CheckIcon from "@mui/icons-material/Check";

type SearchCheckboxProps = {
    name: FieldPath<SearchFormInputs>;
    label: string;
    className?: string;
};

export const SearchCheckbox = ({
    name,
    label,
    className
}: SearchCheckboxProps) => {
    return (
        <Controller<SearchFormInputs>
            name={name}
            defaultValue={false}
            render={({ field: { onChange, value } }) => (
                <FormControlLabel
                    className={className}
                    classes={{ label: `text-sm ${!value && "text-zinc-400"}` }}
                    sx={{ marginLeft: "3px", marginBottom: "8px" }}
                    label={label}
                    control={
                        <Checkbox
                            size="medium"
                            edge="start"
                            onChange={onChange}
                            checked={value}
                            icon={
                                <span className="h-[20px] w-[20px] rounded-[5px] border-[1px] border-solid border-zinc-400 " />
                            }
                            checkedIcon={
                                <span className="h-[20px] w-[20px] rounded-[5px] bg-sh-red">
                                    <CheckIcon className="relative bottom-[4px] left-[2px] h-[16px] w-[16px] text-white" />
                                </span>
                            }
                            sx={{
                                "&.MuiCheckbox-root": {
                                    borderRadius: 16
                                }
                            }}
                        />
                    }
                />
            )}
        />
    );
};
